import SecureBaseModel from './SecureBaseModel';

class CouponModel extends SecureBaseModel { 

    static CHECK_ELIGIBILITY_AND_GET_NEW_PRICE = "coupon-promo/check-eligibility-and-get-new-price"
    static CHECK_ELIGIBILITY = "coupon-promo/check-eligibility"
    static CHECK_VALIDITY = "coupon-promo/check-validity"
    static GET_NEW_PRICE = "coupon-promo/get-new-price"
    static GET_COUPON_ID = "coupon-promo/get-coupon-id"    
    static APPLY_COUPON = "coupon-promo/apply-coupon-to-subscription"

    constructor() {
        super();
    }

    /**
     * @desc call API to verify eligibility for promoCode and return response containing new prices
     * @param {object} elements - object of items for validation
     * param consists of: { userId: value, csMatNo: value, promoCode: value, couponId: value, basePrice: value, totalPrice: value, merchantPrice: value }
     */
    async checkEligibilityAndGetPriceAfterCouponPromo(params) {
        return await this.postData(CouponModel.CHECK_ELIGIBILITY_AND_GET_NEW_PRICE, params); 
    }
    /**
     * @desc call API to verify eligibility for couponId and return response 
     * @param {object} elements - object of items for validation
     * param consists of: { userId: value, csMatNo: value, promoCode: value, couponId: value}
     */
    async checkEligibility(params) {
        return await this.postData(CouponModel.CHECK_ELIGIBILITY, params); 
    }
    /**
     * @desc call API to verify validity of couponId and return response 
     * @param {object} elements - object of items for validation
     * param consists of: {promoCode: value, couponId: value}
     */
    async checkValidity(params) {
        return await this.postData(CouponModel.CHECK_VALIDITY, params); 
    }
    /**
     * @desc call API to fetch the new price given a known valid eligible couponId (for the offer page)
     * @param {object} elements - object of items for validation
     * param consists of: {csMatNo: value, promoCode: value, couponId: value, basePrice: value, merchantPrice: value}
     */
    async getNewPrice(params) {
        return await this.postData(CouponModel.GET_NEW_PRICE, params); 
    }
    /**
     * @desc call API to fetch the couponId for given a known csMatNo and metadata tag (for the offer page using stopIntent)
     * @param {object} elements - object of items for validation
     * param consists of: {csMatNo: value, metadata: value}
     */
    async getCouponId(params) {
        return await this.postData(CouponModel.GET_COUPON_ID, params); 
    }

    /**
     * @desc call API to apply coupon
     * @param {object} elements - object of items for validation
     * param consists of: { couponId: value, subscriptionId: value }
     */
    async applyCoupon(params) {
        return await this.postData(CouponModel.APPLY_COUPON, params);
    }
}

export default CouponModel;